import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import {
  NextProject,
  ProjectAwards,
  ProjectBannerImage,
  ProjectDescription,
  ProjectDownloads,
  ProjectImpacts,
  ProjectLinks,
  ProjectListTextImage,
  ProjectVideos,
} from '../atoms';
import BannerSlider from '../modules/BannerSlider/BannerSlider';

// Search this string (projectAsap) in translations
const pathProject = "projectAsap";

const ProjectAsap = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lng = localStorage.getItem("language");
    i18n.changeLanguage(lng);
  }, [i18n])

  return (
    <div className='projectLayout'>
      <Helmet>
        <title>Asap | Instituto E</title>
      </Helmet>
      <BannerSlider
        slides={
          [
            {
              image: "../../../images/projects/asap/1.jpg",
              alt: "description alt image",
            }
          ]}>
      </BannerSlider>

      {/* Possible to import all inside div with class: "projectLayoutContent", in the following order:
          - ProjectDescription
          - ProjectImpacts
          - ProjectAwards
          - ProjectLinks
          - ProjectVideos
          - ProjectDownloads
          - Outside the div: ProjectBannerImage
          - Outside the div: ProjectListTextImage */}

      <div className='projectLayoutContent'>
        <ProjectDescription
          title={`${t(`${pathProject}.title`)}`}
          subtitle={`${t(`${pathProject}.subtitle`)}`}
          paragraphs={[
            {
              type: "text",
              p: `${t(`${pathProject}.p1`)}`
            }
          ]} />

        <ProjectAwards
          awards={[
            {
              imageLogo: '../../../images/logos/1.svg',
              textAward: `${t(`${pathProject}.awardText1`)}`
            },
            {
              imageLogo: '../../../images/logos/2.svg',
              textAward: `${t(`${pathProject}.awardText2`)}`
            },
            {
              imageLogo: '../../../images/logos/3.svg',
              textAward: `${t(`${pathProject}.awardText3`)}`
            }
          ]} />

        <ProjectVideos
          videos={[
            {
              linkYT: 'https://www.youtube.com/watch?v=5EZJVXcjlKc&t=107s&ab_channel=Osklen',
              textVideo: `${t(`${pathProject}.videoText1`)}`
            }
          ]} />

      </div>

      <NextProject link="project-amazon-guardian"></NextProject>

    </div>
  )
};

export default ProjectAsap;
